var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { x } from '@imtbl/sdk';
import { ethers } from 'ethers';
import { useContext, useState } from 'react';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { deriveSymmetricKey, encryptString } from '../../utils/mpc';
export function useInitWallet() {
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser, _b = _a.magicLinkContext, magic = _b.magic, loginWithMagicLink = _b.loginWithMagicLink;
    var _c = useState(false), completed = _c[0], setCompleted = _c[1];
    var _d = useState(false), acceptTerms = _d[0], setAcceptTerms = _d[1];
    function initWallet() {
        return __awaiter(this, void 0, void 0, function () {
            var magicIsLoggedIn, did, provider, ethSigner, starkPrivateKey, starkSigner, imxProvider, err_1, mpcResult, symmetricKey, _a, encrypted, iv, tag, mpcResult, symmetricKey, _b, encrypted, iv, tag, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(user === null || user === void 0 ? void 0 : user.email))
                            return [2 /*return*/];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 22, , 23]);
                        setServerLoading(true);
                        return [4 /*yield*/, magic.user.isLoggedIn()];
                    case 2:
                        magicIsLoggedIn = _d.sent();
                        if (!magicIsLoggedIn) return [3 /*break*/, 4];
                        return [4 /*yield*/, magic.user.logout()];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4: return [4 /*yield*/, loginWithMagicLink(user.email)];
                    case 5:
                        did = _d.sent();
                        provider = new ethers.BrowserProvider(magic.rpcProvider);
                        return [4 /*yield*/, provider.getSigner()];
                    case 6:
                        ethSigner = _d.sent();
                        return [4 /*yield*/, x.generateLegacyStarkPrivateKey(ethSigner)];
                    case 7:
                        starkPrivateKey = _d.sent();
                        starkSigner = x.createStarkSigner(starkPrivateKey);
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), ethSigner, starkSigner);
                        _d.label = 8;
                    case 8:
                        _d.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, imxProvider.registerOffchain()];
                    case 9:
                        _d.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        err_1 = _d.sent();
                        if (err_1 instanceof Error) {
                            console.log(err_1.message);
                        }
                        return [3 /*break*/, 11];
                    case 11:
                        if (!user.magicLinkWalletAddress) return [3 /*break*/, 16];
                        return [4 /*yield*/, gqlSdk.MpcWalletSetupInitLegacy()];
                    case 12:
                        mpcResult = _d.sent();
                        return [4 /*yield*/, deriveSymmetricKey(ethSigner, mpcResult.mpcWalletSetupInitLegacy.cypherPrivateKeyShare1DKMessage)];
                    case 13:
                        symmetricKey = _d.sent();
                        return [4 /*yield*/, encryptString(symmetricKey, mpcResult.mpcWalletSetupInitLegacy.plainPrivateKeyShare1)];
                    case 14:
                        _a = _d.sent(), encrypted = _a.encrypted, iv = _a.iv, tag = _a.tag;
                        return [4 /*yield*/, gqlSdk.MpcWalletSetupCompleteLegacy({
                                input: { cypherPrivateKeyShare1: encrypted, cypherPrivateKeyShare1Iv: iv, cypherPrivateKeyShare1Tag: tag },
                            })];
                    case 15:
                        _d.sent();
                        return [3 /*break*/, 21];
                    case 16: return [4 /*yield*/, gqlSdk.MpcWalletSetupInit({ input: { magicLinkDid: did } })];
                    case 17:
                        mpcResult = _d.sent();
                        return [4 /*yield*/, deriveSymmetricKey(ethSigner, mpcResult.mpcWalletSetupInit.cypherPrivateKeyShare1DKMessage)];
                    case 18:
                        symmetricKey = _d.sent();
                        return [4 /*yield*/, encryptString(symmetricKey, mpcResult.mpcWalletSetupInit.plainPrivateKeyShare1)];
                    case 19:
                        _b = _d.sent(), encrypted = _b.encrypted, iv = _b.iv, tag = _b.tag;
                        return [4 /*yield*/, gqlSdk.MpcWalletSetupComplete({
                                input: { cypherPrivateKeyShare1: encrypted, cypherPrivateKeyShare1Iv: iv, cypherPrivateKeyShare1Tag: tag },
                            })];
                    case 20:
                        _d.sent();
                        _d.label = 21;
                    case 21:
                        setServerLoading(false);
                        setCompleted(true);
                        reconnectUser();
                        return [3 /*break*/, 23];
                    case 22:
                        _c = _d.sent();
                        setServerLoading(false);
                        return [3 /*break*/, 23];
                    case 23: return [2 /*return*/];
                }
            });
        });
    }
    return { initWallet: initWallet, acceptTerms: acceptTerms, setAcceptTerms: setAcceptTerms, completed: completed };
}
